/* ==========================================================================
   PUREGANIC — Delivery-to-your-area checker
   Vanilla, scoped per section. No libraries.

   Pick your zone -> see same-day eligibility (Cairo/Giza) with a live cut-off
   countdown in Cairo time (skips Friday), or the zone's delivery window + cost.
   Remembers the choice (localStorage), records it on the cart (order attribute),
   then either navigates to a collection or shows the result inline.
   ========================================================================== */
(function () {
  'use strict';

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Current time in Africa/Cairo — independent of the visitor's own timezone.
  function cairoNow() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Africa/Cairo', hour12: false,
      hour: '2-digit', minute: '2-digit', weekday: 'long'
    });
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var hour = parseInt(parts.hour, 10) % 24;
    return { hour: hour, minute: parseInt(parts.minute, 10), weekday: parts.weekday };
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // Next delivery day name, skipping the closed day (Friday).
  function nextDeliveryDay(weekday, skipDay) {
    var idx = DAYS.indexOf(weekday);
    for (var i = 1; i <= 7; i++) {
      var name = DAYS[(idx + i) % 7];
      if (name !== skipDay) return name;
    }
    return '';
  }

  function init(root) {
    if (!root || root.dataset.pgReady === 'true') return;
    root.dataset.pgReady = 'true';

    var cutoffHour = parseInt(root.dataset.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 19;
    var skipDay = root.dataset.skipDay || 'Friday';
    var afterMode = root.dataset.after || 'navigate';
    var collectionUrl = root.dataset.collectionUrl || '/collections/all';
    var expressLine = root.dataset.expressLine || 'Delivered to your door within 1 hour';
    // Master on/off switches (theme editor). Default on unless explicitly "false".
    var enableSameDay = root.dataset.enableSameday !== 'false';
    var enableExpress = root.dataset.enableExpress !== 'false';
    var storeKey = 'pgDeliveryZone';

    var openBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pg-open]'));
    var modal = root.querySelector('[data-pg-modal]');
    var closeEls = Array.prototype.slice.call(root.querySelectorAll('[data-pg-close]'));
    var zoneBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pg-zone]'));
    var zonesWrap = root.querySelector('[data-pg-zones]');
    var resultWrap = root.querySelector('[data-pg-result]');
    var resultLine = root.querySelector('[data-pg-result-line]');
    var resultExpress = root.querySelector('[data-pg-result-express]');
    var backBtn = root.querySelector('[data-pg-back]');
    var shopBtn = root.querySelector('[data-pg-shop]');
    var savedEls = Array.prototype.slice.call(root.querySelectorAll('[data-pg-saved]'));

    var tick = null;
    var selected = null; // { title, cost, sameDay, window }

    // Slide-in like the Nutrition-facts drawer: unhide, then add .is-open next frame so the
    // panel transitions (bottom-sheet on mobile, right drawer on desktop) instead of popping.
    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.documentElement.classList.add('pg-delivery-open');
    }
    root.__pgOpen = openModal; // let any external trigger (e.g. announcement bar) open this popup
    function closeModal() {
      if (modal) {
        modal.classList.remove('is-open');
        var m = modal;
        setTimeout(function () { if (!m.classList.contains('is-open')) m.hidden = true; }, 400);
      }
      document.documentElement.classList.remove('pg-delivery-open');
      if (tick) { clearInterval(tick); tick = null; }
    }

    function showZones() {
      if (zonesWrap) zonesWrap.hidden = false;
      if (resultWrap) resultWrap.hidden = true;
      if (tick) { clearInterval(tick); tick = null; }
    }

    function resultText() {
      if (!selected) return '';
      var cost = selected.cost ? (' · ' + selected.cost + ' LE') : '';
      if (selected.sameDay) {
        var now = cairoNow();
        var nowMin = now.hour * 60 + now.minute;
        var cutMin = cutoffHour * 60;
        var open = (now.weekday !== skipDay) && (nowMin < cutMin);
        if (open) {
          var rem = cutMin - nowMin;
          var h = Math.floor(rem / 60), m = rem % 60;
          var within = h > 0 ? (h + 'h ' + pad(m) + 'm') : (m + 'm');
          return '✅ Same-day delivery to ' + selected.title + ' — order within ' + within + cost;
        }
        return 'Next delivery to ' + selected.title + ': ' + nextDeliveryDay(now.weekday, skipDay) + cost;
      }
      return '🚚 Delivered to ' + selected.title + ' in ' + (selected.window || 'a few days') + cost;
    }

    // Express only shows during its Cairo-time window (e.g. "11:00-20:00"), so we never
    // promise 1-hour delivery when the store can't fulfil it. Blank window = always available.
    function withinExpressHours(range) {
      if (!range) return true;
      var m = range.match(/(\d{1,2}):(\d{2})\D+(\d{1,2}):(\d{2})/);
      if (!m) return true;
      var now = cairoNow();
      var nowMin = now.hour * 60 + now.minute;
      var start = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
      var end = parseInt(m[3], 10) * 60 + parseInt(m[4], 10);
      return nowMin >= start && nowMin < end;
    }

    function renderResult() {
      if (resultLine) resultLine.textContent = resultText();
      if (resultExpress) {
        if (selected && selected.express && withinExpressHours(selected.expressHours)) {
          var c = selected.expressCost ? (selected.expressCost + ' LE') : '150 LE';
          resultExpress.textContent = '⚡ ' + expressLine + ' — ' + c;
          resultExpress.hidden = false;
        } else {
          resultExpress.hidden = true;
        }
      }
    }

    function recordOnCart(title) {
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Delivery area': title } })
        });
      } catch (e) { /* non-blocking */ }
    }

    function showSaved(title) {
      // Update every saved-label on the page (the popup instance + any inline trigger bars).
      document.querySelectorAll('[data-pg-saved]').forEach(function (el) {
        el.textContent = 'Delivering to ' + title;
        el.hidden = false;
      });
    }

    function selectZone(btn) {
      selected = {
        title: btn.dataset.title || '',
        cost: btn.dataset.cost || '',
        sameDay: btn.dataset.sameday === 'true' && enableSameDay,
        window: btn.dataset.window || '',
        express: btn.dataset.express === 'true' && enableExpress,
        expressCost: btn.dataset.expressCost || '',
        expressHours: btn.dataset.expressHours || ''
      };
      try { localStorage.setItem(storeKey, JSON.stringify(selected)); } catch (e) {}
      recordOnCart(selected.title);
      showSaved(selected.title);

      if (zonesWrap) zonesWrap.hidden = true;
      if (resultWrap) resultWrap.hidden = false;
      renderResult();
      // Live-update the same-day countdown once a minute while shown.
      if (tick) clearInterval(tick);
      if (selected.sameDay || selected.express) tick = setInterval(renderResult, 30000);

      if (shopBtn) shopBtn.hidden = (afterMode !== 'navigate');
    }

    openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
    closeEls.forEach(function (b) { b.addEventListener('click', closeModal); });
    zoneBtns.forEach(function (b) { b.addEventListener('click', function () { selectZone(b); }); });
    if (backBtn) backBtn.addEventListener('click', showZones);
    if (shopBtn) shopBtn.addEventListener('click', function () { window.location.href = collectionUrl; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    // Restore a previous choice (show the label on the trigger; don't reopen).
    try {
      var saved = JSON.parse(localStorage.getItem(storeKey) || 'null');
      if (saved && saved.title) showSaved(saved.title);
    } catch (e) {}
  }

  // Make the WHOLE announcement bar clickable (background included), not just the message text.
  // Any bar that hosts a #pg-delivery link gets its container wired to open the popup.
  function bindAnnouncementBars(scope) {
    (scope || document).querySelectorAll('a[href$="#pg-delivery"]').forEach(function (link) {
      var bar = link.closest('.shopify-section') || link.closest('[class*="announcement-bar"]');
      if (!bar || bar.dataset.pgBarBound === '1') return;
      bar.dataset.pgBarBound = '1';
      bar.style.cursor = 'pointer';
      bar.addEventListener('click', function (e) {
        // Let any OTHER real link/button inside the bar behave normally.
        var hit = (e.target && e.target.closest) ? e.target.closest('a, button') : null;
        if (hit && !hit.matches('a[href$="#pg-delivery"]')) return;
        var root = document.querySelector('[data-pg-delivery]');
        if (root && typeof root.__pgOpen === 'function') { e.preventDefault(); root.__pgOpen(); }
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pg-delivery]').forEach(init);
    bindAnnouncementBars(scope);
  }

  // Global trigger: a link to "#pg-delivery" (e.g. an announcement-bar message) or any
  // [data-pg-delivery-open] element opens the delivery popup. Doesn't touch other links.
  if (!document.documentElement.dataset.pgDeliveryGlobal) {
    document.documentElement.dataset.pgDeliveryGlobal = '1';
    document.addEventListener('click', function (e) {
      var t = (e.target && e.target.closest) ? e.target.closest('a[href$="#pg-delivery"], [data-pg-delivery-open]') : null;
      if (!t) return;
      var root = document.querySelector('[data-pg-delivery]');
      if (root && typeof root.__pgOpen === 'function') { e.preventDefault(); root.__pgOpen(); }
    });
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
